/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Vega resources container
 *
 * @file VegaResources.jsx
 * @since 1.0.0
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import { AddLocaleData } from '../config/addLocale';
import ErrorBoundary from '../components/common/ErrorBoundary';
import messages from '../../translations';
import ResourceWrapperContainer from './ResourceWrapperContainer';
import {
  DRAWER_STATE_CLOSED,
  DRAWER_STATE_EXPANDED,
  DRAWER_STATE_OPEN
} from '../common/constants';

import '../assets/styles/style.scss';

class VegaResources extends PureComponent {
  componentDidMount() {
    if (this.context
      && this.context.resourceContext
      && this.context.resourceContext.value) {
      this.context.resourceContext.subscribe(() => this.forceUpdate());
      // Add internationalization data with addLocaleData
      AddLocaleData(this.context.resourceContext.value.locale);
    }
  }

  render() {
    const { drawerState, isCardView } = this.props;

    if (this.context
      && this.context.resourceContext
      && this.context.resourceContext.value) {
      const {
        bookId,
        bulkDownloadStatusCallback,
        cancelCallback,
        currentPageId,
        downloadCallback,
        env,
        locale,
        onResourceClick,
        progressCount,
        removeCallback,
        resourceData,
        retryCallback,
        retryCancelCallback,
        selectedResources,
        showDownload,
        token,
        userRole,
        userSelectedDetails
      } = this.context.resourceContext.value;

      return (
        <IntlProvider locale={locale} messages={messages[locale]}>
          <ErrorBoundary>
            <ResourceWrapperContainer
              bookId={bookId}
              bulkDownloadStatusCallback={bulkDownloadStatusCallback}
              cancelCallback={cancelCallback}
              currentPageId={currentPageId}
              downloadCallback={downloadCallback}
              drawerState={drawerState}
              env={env}
              isCardView={isCardView}
              onResourceClick={onResourceClick}
              progressCount={progressCount}
              removeCallback={removeCallback}
              resourceData={resourceData}
              retryCallback={retryCallback}
              retryCancelCallback={retryCancelCallback}
              selectedResources={selectedResources}
              showDownload={showDownload}
              token={token}
              userRole={userRole}
              userSelectedDetails={userSelectedDetails}
            />
          </ErrorBoundary>
        </IntlProvider>
      );
    }

    return (
      <ResourceWrapperContainer />
    );
  }
}
VegaResources.contextTypes = {
  resourceContext: PropTypes.object
};

VegaResources.propTypes = {
  drawerState: PropTypes.oneOf([
    DRAWER_STATE_CLOSED,
    DRAWER_STATE_EXPANDED,
    DRAWER_STATE_OPEN
  ]),
  isCardView: PropTypes.bool
};

VegaResources.defaultProps = {
  drawerState: DRAWER_STATE_CLOSED,
  isCardView: false
};

export default VegaResources;
